import {
	batteryReductionOneTurn,
	factoryReduction,
	factoryReductionOneTurn,
} from '@lc/const/modifiers';

// TODO send in modifiers array and update cost accordingly
export function calculateFactoryCost(pState: any) {
	let costReducer = 1;
	if (
		pState.modifiers.includes(factoryReduction) ||
		pState.modifiers.includes(factoryReductionOneTurn)
	) {
		costReducer = 2;
	}
	return pState.factories * 2 - costReducer;
}

// TODO create cost functions for batteries and PR to update price when effected
export function calculateBatteryCost(pState: any) {
	let batteryCost = 1;

	if (
		pState.batteries >= 1 &&
		!pState.modifiers.includes(batteryReductionOneTurn)
	) {
		batteryCost = 2;
	}

	return batteryCost;
}
